import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import styles from "./NewsDetails.module.sass";
import NewsSection from "../../components/NewsSection";
import RelatedNewsCard from "../../components/RelatedNewsCard";
import { Helmet } from "react-helmet";
import TopicsOnAgenda from "../../components/TopicsOnAgenda";
import SubscribeforUpdates from "../../components/SubscribeforUpdates";
import ReactLoading from "react-loading";
import {
  LinkedinShareButton,
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
export default function NewsDetails() {


  const subscribeRef  = useRef(null);
  const { url } = useParams();
  const [News, SetNews] = useState({
    data: null,
    isPopupVisible: false,
    isTooltipVisible: false,
    loading: false,
    error: null,
    relatedNewsData: [],
  });
  console.log("news data--", News);
  // Fetch news details
  const getNewsDetails = useCallback(async () => {
    try {
      SetNews((prev) => ({ ...prev, loading: true }));
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_SERVER_URL}/news/${url}`
      );
      SetNews((prev) => ({
        ...prev,
        data: data.data,
        socialMediaShare: data.data.socialMediaShare,
        relatedNewsData: data.relatedNews,
      }));
    } catch (error) {
      SetNews((prev) => ({
        ...prev,
        error: "Failed to fetch news details. Please try again later.",
      }));
      console.error("Error fetching news details:", error);
    } finally {
      SetNews((prev) => ({ ...prev, loading: false }));
    }
  }, [url]);

  useEffect(() => {
    getNewsDetails();
  }, [getNewsDetails]);
  const whatsappShareUrl = encodeURI(window.location.href);
  const whatsappTitle =  News?.data?.metatitle || News?.data?.title || "";
  // Toggle share popup visibility
  const togglePopup = () => {
    SetNews((prev) => ({
      ...prev,
      isPopupVisible: !prev.isPopupVisible,
    }));
  };
  const handleScroll = () => {
    subscribeRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // Handle copy URL functionality
  const currentUrl = window.location.href;
  const handleCopy = () => {
    const currentUrl = window.location.href;
    navigator.clipboard
      .writeText(currentUrl)
      .then(() => {
        SetNews((prev) => ({ ...prev, isTooltipVisible: true }));
        setTimeout(() => {
          SetNews((prev) => ({ ...prev, isTooltipVisible: false }));
        }, 2000);
      })
      .catch((error) => {
        console.error("Failed to copy URL: ", error);
      });
  };

  //   meta title and description
  const metaTitle = News?.data?.metatitle || News?.data?.title || "";
  const rawmetaDescription = News?.data?.metadescription ||News?.data?.shortdescription || "";
  const metaDescription = rawmetaDescription.replace(/<[^>]*>?/gm, "");

  const metaImage =
    News?.data?.image ||
    `${process.env.REACT_APP_API_SERVER_URL}/${News?.data?.image}`;
  if (News.loading) {
    return (
      <div
        className="pt-3 text-center"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100vh",
        }}
      >
        <ReactLoading
          type={"spinningBubbles"}
          color="var(--primary-color)"
          height={"70px"}
          width={"70px"}
        />
      </div>
    );
  }

  if (News?.error) {
    return <div className={styles.error}>{News?.error}</div>;
  }
  const generateHashtags = (title) => {
    const stopWords = [
      "the",
      "is",
      "and",
      "a",
      "to",
      "of",
      "at",
      "under",
      "that",
      "use",
      "in",
      "it",
      "on",
      "for",
      "with",
    ];
    const hashtags = title
      .split(/\s+/)
      .filter((word) => !stopWords.includes(word.toLowerCase()))
      .map((word) => `#${word.replace(/[^\w-]/g, "")}`);
    return hashtags.join(" ");
  };

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={metaImage} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={metaImage} />
      </Helmet>
      {/* Upper Section */}
      <div className={styles.backButtonContainer}>
          <div className={styles.backButtonPartContainer}>
          <Link className={styles.backButton} to="/news">
            <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2227 5.75C13.2227 6.24219 12.8398 6.625 12.375 6.625H3.98047L6.85156 9.52344C7.20703 9.85156 7.20703 10.4258 6.85156 10.7539C6.6875 10.918 6.46875 11 6.25 11C6.00391 11 5.78516 10.918 5.62109 10.7539L1.24609 6.37891C0.890625 6.05078 0.890625 5.47656 1.24609 5.14844L5.62109 0.773438C5.94922 0.417969 6.52344 0.417969 6.85156 0.773438C7.20703 1.10156 7.20703 1.67578 6.85156 2.00391L3.98047 4.875H12.375C12.8398 4.875 13.2227 5.28516 13.2227 5.75Z" fill="#171717"/>
            </svg>
            Back to all News</Link>
        </div>
      </div>
      <div className={styles.upperPartContainer}>
        <div className={styles.upperPart}>
          <p className={styles.categoryText}>{News?.data?.category?.name}</p>
          <h1>{News?.data?.title}</h1>
          <div
            className={styles.descriptionText}
            dangerouslySetInnerHTML={{
              __html: News?.data?.shortdescription,
            }}
          ></div>
          <div className={styles.categoryContainer}>
            <p>{News?.data?.publishdate}</p>
            {News.isPopupVisible ? (
              <div className={styles.sharePopUpContainer}>
                <button onClick={togglePopup}>X</button>
                <h6>Share</h6>
                <div className={styles.shareIconsContainer}>
                  {News?.socialMediaShare.LinkedIn && (
                    <div className={styles.shareIconBox}>
                      <LinkedinShareButton
                        url={currentUrl} // Add the URL prop
                        title={News?.data?.title} // Title of the news
                        summary={News?.data?.shortdescription} // Short description
                        source={currentUrl} // Source URL
                      >
                        <img
                          src="/images/icons/share-linkedIn.png"
                          alt="Share on LinkedIn"
                        />
                      </LinkedinShareButton>
                    </div>
                  )}

                  {News?.socialMediaShare.Whatsapp && (
                    <div className={styles.shareIconBox}>
                      <WhatsappShareButton
                        url={whatsappShareUrl}
                        title={News?.data?.title} // Email subject
                      >
                        <img
                          src="/images/icons/share-whatsapp.png"
                          alt="Share via Email"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent react-share default behavior

                            const message = `${whatsappTitle}\n${whatsappShareUrl}`;
                            const link = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
                          
                            window.open(link, "_blank");
                          }}
                        />
                      </WhatsappShareButton>
                    </div>
                  )}

                  {News?.socialMediaShare.Facebook && (
                    <div className={styles.shareIconBox}>
                      <FacebookShareButton
                        url={currentUrl} // Add the URL prop
                        quote={News?.data?.shortdescription}
                        picture={`${process.env.REACT_APP_API_SERVER_URL}/${News?.data?.image}`}
                      >
                        <img
                          src="/images/icons/share-facebook.png"
                          alt="Share via Email"
                        />
                      </FacebookShareButton>
                    </div>
                  )}
                  {News?.socialMediaShare.Twitter && (
                    <div className={styles.shareIconBox}>
                      <TwitterShareButton
                        url={currentUrl} // Add the URL prop
                        title={News?.data?.title} // Email subje
                      >
                        <img
                          src="/images/icons/share-twitter.png"
                          alt="Share via Email"
                        />
                      </TwitterShareButton>
                    </div>
                  )}
                  {News?.socialMediaShare.Pinterest && (
                    <div className={styles.shareIconBox}>
                      <PinterestShareButton
                        url={currentUrl}
                        media={`${process.env.REACT_APP_API_SERVER_URL}/${News?.data?.image}`}
                        description={News?.data?.shortdescription}
                      >
                        <img
                          src="/images/icons/share-pinterest.png"
                          alt="Share via Email"
                        />
                      </PinterestShareButton>
                    </div>
                  )}

                  {News?.socialMediaShare.email && (
                    <div className={styles.shareIconBox}>
                      <EmailShareButton
                        url={currentUrl} // Add the URL prop
                        subject={News?.data?.title} // Email subject
                        // body={News?.data?.description} // Email body
                      >
                        <img
                          src="/images/icons/share-email.png"
                          alt="Share via Email"
                        />
                      </EmailShareButton>
                    </div>
                  )}
                  <div className={styles.shareIconBox} onClick={handleCopy}>
                    <img src="./images/icons/share-copy.png" alt="Copy" />
                    {News.isTooltipVisible && (
                      <div className={styles.tooltip}>URL Copied!</div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <button onClick={handleScroll} >Subscirbe</button>
                <button onClick={togglePopup} className={styles.share}>Share</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Lower Section */}
      <div className={styles.lowerPart}>
        <div className={styles.left}>
          <div className={styles.content}>
            <img
              src={`${process.env.REACT_APP_API_SERVER_URL}/${News?.data?.image}`}
              alt="News article"
              className={styles.dynamicImage}
            />
            <p
              className={styles.dynamicText}
              dangerouslySetInnerHTML={{
                __html: News?.data?.description,
              }}
            ></p>
          </div>
        </div>
        <div className={styles.right}>
          <NewsSection isFullWidth={true} />
        </div>
      </div>
      {News?.relatedNewsData && News?.relatedNewsData?.length > 0 ? (
        <div className={styles.relatedEventsContainer}>
          <h1>Related News</h1>
          <div className={styles.relatedInnerContainer}>
            {News?.relatedNewsData.map((news, index) => {
              return (
                <RelatedNewsCard
                  key={index}
                  date={news?.publishdate}
                  title={news?.title}
                  category={news?.category?.name}
                  image={news?.image}
                  url={news?.url}
                />
              );
            })}
          </div>
        </div>
      ) : null}
      <div style={{ width: "100%" }}>
        <TopicsOnAgenda isNews={true} />
      </div>
        <div ref={subscribeRef} style={{ width: "100%" }}>
          <SubscribeforUpdates />
        </div>
    </div>
  );
}
